import { ButtonProps, Box, Button } from '@cad-arc';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useOpenEventPanel } from './use-open-event-panel';
import { useUserActionTracker } from '../monitoring/user-action-tracker/use-user-action-tracker';
import { logInfo } from '../monitoring/log';

export function NewEventButton(props: ButtonProps): React.ReactElement {
    const openEventPanel = useOpenEventPanel();
    const { canCreateEvent } = useEnabledFeatures();
    const userActionTracker = useUserActionTracker();
    return canCreateEvent ? (
        <Box ml="10">
            <Button
                leadingVisual="Add"
                type="button"
                size="sm"
                variant="outline"
                onClick={(e) => {
                    openEventPanel({});
                    logInfo('Clicked new event button');
                    userActionTracker?.trackNewEvent(
                        {
                            newEventTrigger: 'BUTTON',
                        },
                        e
                    );
                }}
                {...props}
            >
                New Event
            </Button>
        </Box>
    ) : (
        <div />
    );
}
